import { render, staticRenderFns } from "./LevelSetting.vue?vue&type=template&id=4647a6d8&scoped=true"
import script from "./LevelSetting.vue?vue&type=script&lang=ts"
export * from "./LevelSetting.vue?vue&type=script&lang=ts"
import style0 from "./LevelSetting.vue?vue&type=style&index=0&id=4647a6d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4647a6d8",
  null
  
)

export default component.exports